import request from '@/utils/request'

// 查询用户捐款记录列表
export function listUserDonation(query) {
  return request({
    url: '/h5/userDonation/list',
    method: 'get',
    params: query
  })
}

// 查询用户捐款记录详细
export function getUserDonation(id) {
  return request({
    url: '/h5/userDonation/' + id,
    method: 'get'
  })
}

// 获取用户捐款金额及个数
export function myDonation() {
  return request({
    url: '/h5/userDonation/myDonation' ,
    method: 'get'
  })
}

// 我的捐款项目
export function myDonationList() {
  return request({
    url: '/h5/userDonation/myDonationList' ,
    method: 'get'
  })
}
